import { render, staticRenderFns } from "./OrganismCertifications.vue?vue&type=template&id=24b73d6a&scoped=true&"
import script from "./OrganismCertifications.vue?vue&type=script&lang=js&"
export * from "./OrganismCertifications.vue?vue&type=script&lang=js&"
import style0 from "./OrganismCertifications.vue?vue&type=style&index=0&id=24b73d6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b73d6a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesCommonMoleculeCertifications: require('/app/components/molecules/common/MoleculeCertifications.vue').default})
